import {useContext} from 'react'
import {CustomLanding36252Context} from '../../reducer'
import {InnerSection} from '../InnerSection'
import {Container} from './components/Container'
import {Mt5Links} from './components/Mt5Links'
import {PspLinks} from './components/PspLinks'
import {SocialLinks} from './components/SocialLinks'

export const Links = () => {
  const [state] = useContext(CustomLanding36252Context)

  return (
    <Container>
      <InnerSection inverse={state.language === 'ar'}>
        <SocialLinks />
        <PspLinks />
        <Mt5Links />
      </InnerSection>
    </Container>
  )
}
